import { useAuth } from "@src/auth"
import { userIsCandidate } from "@src/helpers"
import styles from './style.module.css'
import Link from "next/link"
import NotificationItem from "./NotificationItem"

export default function NotificationsDropdown({ userType, notifications }){
    const { user }  = useAuth()
    
    const linkUrl = userIsCandidate(user) ? (
        "/candidate/dashboard/notifications"
    ) : "/employer/dashboard/notifications"

    const renderNotificationsButton = () => {
        if (!notifications?.length) {
            return (
                <div className={styles.noneFound}>
                    No Notifications
                </div>                
            )
        } else {
            return (
                <Link href={linkUrl} passHref>
                    <a>
                        <div className={styles.seeAll}>
                            View All Notifications
                        </div>
                    </a>
                </Link>                
            )
        }
    }
    
    return (
        <div className={styles.notifyMenu}>
            <div className={styles.noteTriangle} />
            <div className={styles.notificationsWrapper}>
                {notifications.map(item => <NotificationItem key={item.name} item={item} />)}
                {renderNotificationsButton()}
            </div>
        </div>
    )
}